import { Component, OnInit } from '@angular/core';

import { NotificationService } from '@pm-ui/core-services';
//import { DocumentService } from '@pm-ui/pm-services';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { IFileStatusVM, IFileUploadOptionsVM } from '../../models';

@Component({
  selector: 'pm-ui-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {
  readonly options: IFileUploadOptionsVM = {
    title: 'File Uploader',
    message: 'Drag and Drop Your Document or Click to Upload',
    accept: '*/*',
    uploadedFiles: [],
  };

  constructor(
    //private documentService: DocumentService,
    private notificationService: NotificationService,
    private bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
  }

  onFileChange(event: Event) {
    const fileControl = event.target as HTMLInputElement;

    if (fileControl
      && fileControl.files
      && fileControl.files.length) {

      for (let x = 0; x < fileControl.files.length; x++) {
        const file = fileControl.files[x];
        const obj: IFileStatusVM = { fileName: '', savedFileName: '', progress: 0, isDone: false, isFailed: false };

        obj.fileName = file.name;
        this.options.uploadedFiles = this.options.uploadedFiles || [];
        this.options.uploadedFiles.push(obj);
       // this.uploadTempDocumentWithProgress(file, obj);
      }
    }
  }

  onRemoveFile = (idx: number): void => {
    if (this.options.uploadedFiles && idx >= 0 && idx < this.options.uploadedFiles.length)
      this.options.uploadedFiles.splice(idx, 1);
  }

  onConfirm = (): void => {
    if (this.bsModalRef?.content.callback)
      this.bsModalRef?.content.callback(this.options.uploadedFiles);

    this.onClose();
  }

  onClose = (): void => {
    this.bsModalRef?.hide();
  }

  
}
